import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuestionCategory } from 'src/app/shared/models/course';
import { Message, PrivilegeType } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { CourseService } from 'src/app/shared/services/course.service';
import { DataService } from 'src/app/shared/services/data.service';
import { QuestionCategoryCrudComponent } from '../question-category-crud/question-category-crud.component';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-question-category-list',
  templateUrl: './question-category-list.component.html',
  styleUrls: ['./question-category-list.component.scss']
})
export class QuestionCategoryListComponent implements OnInit {
  public questionCategories: QuestionCategory[] = [];
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;

  constructor(
    private modalService: NgbModal,
    private commonService: CommonService,
    private questionCategoryService: CourseService,
    private dataService: DataService,
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.getQuestioncategories();
  }

  private getQuestioncategories(clear: boolean = true) {
    if (clear) {
      this.isLoading = true;
      this.questionCategories = [];
    }
    this.questionCategoryService.getQuestionCategories().subscribe({
      next: (questioncategories: QuestionCategory[]) => {
        this.questionCategories = questioncategories.sort((a, b) => a.id - b.id);
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
      }
    });
  }

  public upsertQuestionCategory(questionCategory?: QuestionCategory) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(QuestionCategoryCrudComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.questionCategory = questionCategory;
    modalRef.componentInstance.questioncategories = this.questionCategories.filter(t => t.id !== questionCategory?.id);
    modalRef.componentInstance.passEntry.subscribe((response: QuestionCategory) => {
      if (!response.id) {
        this.getQuestioncategories(true);
      }
    });
  }

  public toggleQuestionCategoryStatus(questionCategory: QuestionCategory) {
    if (!this.privilege.canEdit) {
      setTimeout(() => { questionCategory.disabled = !questionCategory.disabled }, 0);
      return;
    }
    this.questionCategoryService.toggleQuestionCategoryStatus(questionCategory).subscribe({
      next: (response: Message) => {
        if (response) {
          this.commonService.setToastr(200, `Question Category ${questionCategory.name} is now ${questionCategory.disabled ? 'disabled' : 'enabled'}!`);
        }
      },
      error: (error: HttpErrorResponse) => {
        questionCategory.isDeleteInProgress = false;
      },
    });
  }

  public deleteQuestionCategory(questionCategory: QuestionCategory, index: number) {
    if (!this.privilege.canDelete) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.questionCategory = "Question Category deletion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to delete question Category";
    modalRef.componentInstance.message = questionCategory?.name;
    modalRef.componentInstance.label = 'Question Category';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        questionCategory.isDeleteInProgress = true;
        this.questionCategoryService.deleteQuestionCategory(questionCategory.id).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, message.text);
              this.questionCategories.splice(index, 1);
              this.getQuestioncategories(false);
              questionCategory.isDeleteInProgress = false;
            } else {
              this.commonService.setToastr(500, message.text);
              questionCategory.isDeleteInProgress = false;
            }
          },
          error: (error: HttpErrorResponse) => {
            questionCategory.isDeleteInProgress = false;
          },
        });
      }
    });
  }

  public getBadgeClassForStatus(approvalStatus: string): string {
    switch (approvalStatus?.toUpperCase()) {
      case 'DRAFT':
        return 'badge bg-secondary text-white rounded-pill';
      case 'IN_REVIEW':
        return 'badge bg-info text-white rounded-pill';
      case 'REVIEWED':
        return 'badge bg-warning text-dark rounded-pill';
      case 'RELEASED':
        return 'badge bg-success text-white rounded-pill';
      default:
        return 'badge bg-light text-dark rounded-pill';
    }
  }

  public formatStatus(label: string): string {
    return label
      ?.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }
}
